import { useRef, useState } from 'react'
import { setFlashMessage, userIsLogged, userRedirectLogin } from '../../helpers'
import { API_ROUTES } from '../../constants/apiRoutes'
import apiClient from '../../services/api/apiClient'
import { getSauterDeviceLabels } from '../../services/deviceLabelsService'
import House from './House';
import loaderGif from '../../resources/img/loader3.gif'
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(ChartDataLabels);


export class HouseElecManagement {

    loadConsoIntoTemplate(clearCache = false) {
        return new Promise((resolve, reject) => {
            this._setIsLoading(true)
            if (!this.canvasCharts) {
                this.canvasCharts = []
            }
            // Clean canvas charts
            ['elecConsoDailyCanvas'].forEach((element) => {
                this.canvasCharts[element] ? this.canvasCharts[element].destroy() && delete this.canvasCharts[element] : null
            })
            let url = API_ROUTES.SAUTER_ELEC_CONSOS
            if (clearCache === true) {
                url += '?clearCache=true'
            }

            apiClient.get(url).then((data) => {
                const consoDevices = data.devices
                let chartDailyDataLabels = [], chartDailyDataPoints = [], chartDailyDataPointsLabels = []
                const kwhPrice = data.kwhPrice
                if (!consoDevices) {
                    setFlashMessage('error', 'Erreur lors de la récupération des données de consommation électrique : pas de données disponibles')
                    return
                }

                const dailyWrapper = document.getElementById('elecConsoDailyCanvasWrapper')
                if (dailyWrapper) {
                    dailyWrapper.innerHTML = '<canvas id="elecConsoDailyCanvas" style="height:45vw; max-height:300px"></canvas>'
                }
                Object.keys(consoDevices).forEach((deviceKey) => {
                    const consoDaily = consoDevices[deviceKey]
                    let chartDailyDataPointsCurrent = []
                    const deviceLabel = this._deviceLabels ? this._deviceLabels[deviceKey] || deviceKey : deviceKey
                    chartDailyDataPointsLabels.push(deviceLabel)
                    Object.keys(consoDaily).forEach((date) => {
                        const dt = date.split('-')
                        const dateReworked = dt[2] + ' / ' + dt[1]
                        const consoDay = consoDaily[date]
                        // If date label not exists, add it
                        if (!chartDailyDataLabels.includes(dateReworked)) {
                            chartDailyDataLabels.push(dateReworked)
                        }
                        if (this._consoElecUnitEuro === true) {
                            chartDailyDataPointsCurrent.push((consoDay * kwhPrice).toFixed(2))
                        } else {
                            chartDailyDataPointsCurrent.push(consoDay)
                        }
                    })
                    chartDailyDataPoints.push(chartDailyDataPointsCurrent)
                });

                // Clean canvas charts
                ['elecConsoDailyCanvas'].forEach((element) => {
                    this.canvasCharts[element] ? this.canvasCharts[element].destroy() && delete this.canvasCharts[element] : null
                })

                let yLabel = this._consoElecUnitEuro === true ? 'Euros (estimé)' : 'kW / h'
                this._buildChart('bar', document.getElementById('elecConsoDailyCanvas'), chartDailyDataLabels, chartDailyDataPoints, true, chartDailyDataPointsLabels, yLabel)
                const consoPart = document.getElementById('elecConsoPart')
                if (consoPart) {
                    consoPart.classList.remove('d-none')
                }
            }).catch((error) => {
                setFlashMessage('error', 'Erreur lors de la récupération des données de consommation électrique')
            }).finally(() => {
                this._setIsLoading(false)
                resolve()
            })
        })
    }

    _buildChart(chartType, canvasElement, dataLabels, dataPoints, useDataLabels = true, labels = null, yLabel = null) {
        if (!canvasElement) {
            return
        }

        const options = { backgroundColor: '#2865a7' }
        let plugins = []
        if (useDataLabels === true) {
            options.plugins = {
                legend: {
                    display: true,
                    position: 'top',
                    align: 'end', // 'start' | 'center' | 'end'
                },
                datalabels: {
                    color: 'black',
                    align: 'end',
                    anchor: 'end',
                    font: { weight: 'bold' },
                }
            }
            plugins = [ChartDataLabels]
        }
        options.pointBorderWidth = 6
        options.pointHoverBorderWidth = 12
        options.scales = {
            y: {
                //stacked: true,
                beginAtZero: true,
                position: 'right',
                title: {
                    display: yLabel !== null ? true : false,
                    text: yLabel, // <-- label affiché sur l'axe Y
                    color: '#000',
                    font: { weight: 'bold', size: 12 },
                }
            },
            x: {
                //stacked: true,
            }
        }

        const backgroundColors = ['#2865a7', '#9d711d', '#9b9338', '#4a772e', '#2e5d71', '#6e3a6e', '#8c3b45', '#616161', '#2e2e2e', '#000000']
        let dataSets = []

        dataPoints.forEach((item, index) => {
            let dataLabelsCurrentData = {
                align: 'end',
                anchor: 'end',
                color: backgroundColors[index],
                offset: 5
            }
            dataSets.push({
                backgroundColor: backgroundColors[index],
                label: labels[index],
                data: dataPoints[index],
                borderColor: backgroundColors[index],
                fill: false,
                datalabels: dataLabelsCurrentData
            })
        })

        let barChart = new Chart(canvasElement, {
            type: chartType,
            plugins: plugins,
            data: {
                labels: dataLabels,
                datasets: dataSets,
            },
            options: options
        })
        this.canvasCharts[canvasElement.id] = barChart
    }



}

export default function HouseSauterElec() {

    const [isLogged, setIsLogged] = useState(false)
    if (isLogged !== true) {
        userIsLogged().then((isLogged) => {
            if (isLogged === false) {
                userRedirectLogin()
            }
            setIsLogged(isLogged)
        })
    }

    const manager = new HouseElecManagement()
    const [consoElecUnitEuro, setSonsoElecUnitEuro] = useState(false)
    const [isLoading, setIsLoading] = useState(null)
    const [deviceLabels, setDeviceLabels] = useState({})
    const [deviceLabelsLoaded, setDeviceLabelsLoaded] = useState(false)
    const refLabelsLoadStarted = useRef(false)

    manager._consoElecUnitEuro = consoElecUnitEuro
    manager._setIsLoading = setIsLoading
    manager._deviceLabels = deviceLabels

    if (isLogged && !deviceLabelsLoaded) {
        if (!refLabelsLoadStarted.current) {
            refLabelsLoadStarted.current = true
            getSauterDeviceLabels().then((labels) => {
                setDeviceLabels(labels)
            }).finally(() => {
                setDeviceLabelsLoaded(true)
            })
        }
    }

    if (isLoading === null && isLogged === true && deviceLabelsLoaded === true) {
        manager.loadConsoIntoTemplate()
    }

    if (isLogged) {
        return (
            <>
                <House activeTab="elec" />
                <div className="conteneur">
                    <div id="flashMessages"></div>
                    <div id="elecConsoPart">
                        <div className="text-center">
                            <h4><i className="fa fa-bolt small"></i> Conso électrique</h4>
                            <div className="text-center">
                                <strong>Kw/H</strong>
                                <button className={"btn btn-toggle " + (consoElecUnitEuro ? 'enabled' : '')} onClick={() => { setIsLoading(null); setSonsoElecUnitEuro(!consoElecUnitEuro) }}>
                                    <span className="btn-toggle-content"></span>
                                </button>
                                <strong>&nbsp;€</strong>
                                <br /><br />

                                <img src={loaderGif} className={isLoading !== true ? "d-none" : ''} style={{ width: "25%", maxWidth: '150px' }} id="loaderElec" />
                            </div>
                            <br />

                            <div style={{ width: '100%', overflowX: "auto", overflowY: "hidden", direction: 'rtl' }}>
                                <div style={{ width: "700px", height: "300px", maxWidth: '2000px', direction: 'ltr' }}>
                                    <div id="elecConsoDailyCanvasWrapper" className={isLoading === true ? "d-none" : ''}></div>
                                </div>
                            </div>

                            <div className="text-center mt-5">
                                <br /><br />
                                <button onClick={() => { manager.loadConsoIntoTemplate(true) }} className="btn btn-secondary btn-sm btn-warn">Vider le cache</button>
                            </div>
                        </div>
                    </div>

                </div>
            </>)
    }
}
